import { z } from "zod";
import { POLL_OPTION_LABEL_MAX, POLL_OPTIONS_MAX, POLL_OPTIONS_MIN, POLL_QUESTION_MAX } from "./poll.js";

export const createPollSchema = z.object({
	question: z.string().min(1).max(POLL_QUESTION_MAX),
	options: z.array(z.string().min(1).max(POLL_OPTION_LABEL_MAX)).min(POLL_OPTIONS_MIN).max(POLL_OPTIONS_MAX),
	client_id: z.uuid().optional(),
});

export type CreatePollPayload = z.infer<typeof createPollSchema>;

export const votePollSchema = z.object({
	option_id: z.string(),
});

export type VotePollPayload = z.infer<typeof votePollSchema>;

export const editPollSchema = z.object({
	question: z.string().min(1).max(POLL_QUESTION_MAX),
});

export type EditPollPayload = z.infer<typeof editPollSchema>;
